import React from 'react';
import { Card } from 'antd';

interface MobileSectionCardProps {
  title?: React.ReactNode;
  extra?: React.ReactNode;
  children: React.ReactNode;
  style?: React.CSSProperties;
  bodyStyle?: React.CSSProperties;
}

const MobileSectionCard: React.FC<MobileSectionCardProps> = ({
  title,
  extra,
  children,
  style,
  bodyStyle,
}) => (
  <Card
    size="small"
    title={title}
    extra={extra}
    style={{
      borderRadius: 20,
      border: '1px solid rgba(231, 237, 244, 0.92)',
      boxShadow: '0 12px 32px rgba(11, 37, 69, 0.08)',
      overflow: 'hidden',
      ...style,
    }}
    styles={{
      body: {
        padding: 16,
        ...bodyStyle,
      },
    }}
  >
    {children}
  </Card>
);

export default MobileSectionCard;
